import { api } from './client'
import type {
  EntityDef,
  MappingDefinition,
  SuggestMappingResult,
  UploadResult,
  ValidationReport,
} from './types'

export interface SubmitImportRequest {
  uploadId: string
  qboCompanyId: string
  mapping: MappingDefinition
  saveMappingAs?: string
  sheet?: string | null
}

export const importApi = {
  upload(file: File, signal?: AbortSignal): Promise<UploadResult> {
    const form = new FormData()
    form.append('file', file)
    return api.post<UploadResult>('/uploads', form, { signal })
  },

  /** Re-parse an uploaded file against a different sheet. */
  reparse(uploadId: string, sheet: string): Promise<UploadResult> {
    return api.post<UploadResult>(`/uploads/${uploadId}/reparse?sheet=${encodeURIComponent(sheet)}`, {})
  },

  entities(): Promise<EntityDef[]> {
    return api.get<EntityDef[]>('/import/entities')
  },

  suggestMapping(uploadId: string, entityType: string, sheet?: string | null): Promise<SuggestMappingResult> {
    return api.post<SuggestMappingResult>('/import/suggest-mapping', { uploadId, entityType, sheet })
  },

  /** Persists nothing, so it is safe to re-run on every mapping tweak. */
  validate(uploadId: string, mapping: MappingDefinition, sheet?: string | null, signal?: AbortSignal): Promise<ValidationReport> {
    return api.post<ValidationReport>('/import/validate', { uploadId, mapping, sheet }, { signal })
  },

  submit(request: SubmitImportRequest): Promise<{ jobId: string }> {
    return api.post<{ jobId: string }>('/import/submit', request)
  },
}
